import React, { useEffect } from 'react'
import { View, Text } from 'react-native'
import arenaIcon from '../../../assets/arena/icon.png'
import arenaIconMask from '../../../assets/arena/icon_mask.png'
import lockIcon from '../../../assets/icons/locked.png'
import trophyIcon from '../../../assets/icons/trophy.png'
import arrowIcon from '../../../assets/icons/arrowDown.png'
import computeFilters from '../../helpers/computeFilters'
import levels from '../../constants/levels'
import { useStateHooks } from '../../state/provider'
export default ({ onSelect }) => {
  const { state: {
    screen,
    overlay,
    currentLevel,
    latestArenaResult,
    arenas,
  }, ...actions } = useStateHooks().app
  return (
    <>
      <View style={{ flexWrap: 'wrap', flexDirection: 'row', justifyContent: 'center', maxWidth: 400, height: '100%', margin: 'auto' }}>
        {levels.map((l, idx) => {
          const locked = arenas[idx].locked
          const arenaWon = arenas[idx].result === 1
          const arenaDone = [2, 3].includes(arenas[idx].result)
          const currentArena = !locked && arenas[idx + 1] && arenas[idx + 1].locked
          return (
            <View key={l.id} style={{ width: 100, height: 100, position: 'realtive' }}
              onTouchEnd={() => !locked ? onSelect(idx) : null}
              onClick={() => !locked ? onSelect(idx) : null}
            >
              <img width={100} height={100} src={arenaIconMask} style={{
                filter: computeFilters(l.arena.tint),
                position: 'absolute',
                opacity: 0.5
              }}/>
              <img width={100} height={100} src={arenaIcon} style={{ visibility: locked ? 'hidden' : 'visible '}}/>
              {locked && <img src={lockIcon} style={{
                position: 'absolute', width: 50, height: 50, top: '40%', left: '25%',
                opacity: 0.8
              }} />}
              {arenaWon && <img src={trophyIcon} style={{ position: 'absolute', width: 50, height: 50, top: '10%', left: '25%',
                filter: computeFilters('#ffcd0a'),
              }} />}
              {currentArena && <img src={arrowIcon} style={{ position: 'absolute', width: 50, height: 50, top: '10%', left: '25%',
                filter: computeFilters('#dbdbdb'),
              }} />}
              
              <View style={{ alignItems: 'center' }}>
                <Text>{l.arena.name}</Text>
              </View>
            </View>
          )
      })}
      </View>
    </>
  )
}


